import moment from 'moment'
import { useFilters } from '@components/v2/dateFilter/hooks/useFilters'

export const useUserActivitiesParams = () => {
  const { numberOfDaysToFilter } = useFilters()
  const now = moment().endOf('day')
  const timeTo = now.toISOString()
  const timeFrom = now
    .clone()
    .subtract(Number(numberOfDaysToFilter), 'days')
    .startOf('day')
    .toISOString()

  return {
    timeFrom,
    timeTo,
    numberOfDaysToFilter,
  }
}
